import Reflux from 'reflux';

export default {
  loadChats: Reflux.createAction({ sync: false }),
  getNewChats: Reflux.createAction({ sync: false }),
};
